import './toast.css';

interface SessionToastProps {
  onLogin: () => void;
}

const SessionToast = ({ onLogin }: SessionToastProps) => (
  <div>
    <p>Your session has expired. Please log in again.</p>
    <button className="toast-button" onClick={onLogin}>
      Log in
    </button>
  </div>
);

export default SessionToast;
